import ActionCard from "@/components/ActionCard";
import useCapabilities, { useDenyAuthorization } from "@/hooks/useCapabilities";
import { useFlags, useFlagsLoaded } from "@/hooks/useFeatureFlags";
import usePageTitle from "@/hooks/usePageTitle";
import { Path, useNavigate } from "@/router";
import { useEffect } from "react";
import TabLayout from "../_TabLayout";
import { canShowCommissionPlatformChrome, canShowGrpFinanceChrome, canViewFinance } from "./_utils";

export default function FinancePage() {
  usePageTitle("/billing/finance", "Billing | Finance");
  const navigate = useNavigate();
  const flags = useFlags();
  const flagsLoaded = useFlagsLoaded();
  const { loaded, capabilities } = useCapabilities();
  const denyAuthorization = useDenyAuthorization();
  const canViewGrp = canShowGrpFinanceChrome(flags, capabilities);
  const canViewCommission = canShowCommissionPlatformChrome(flags, capabilities);
  const canViewFinanceLanding = canViewFinance(flags, capabilities);

  useEffect(() => {
    if (!loaded || !flagsLoaded) return;
    if (!canViewFinanceLanding) denyAuthorization("/billing/orders" as Path);
  }, [loaded, flagsLoaded, canViewFinanceLanding, denyAuthorization]);

  return (
    <TabLayout>
      {(canViewGrp || canViewCommission) && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-[90rem] pt-12">
          {canViewGrp && (
            <div>
              <ActionCard
                actionFn={() => navigate("/billing/finance/grp")}
                iconName="volunteer_activism"
                title="Golf Retirement Plus"
                text="Manage member and sponsor contributions for the Golf Retirement Plus benefit program."
              />
            </div>
          )}
          {canViewCommission && (
            <div>
              <ActionCard
                actionFn={() => navigate("/billing/finance/commission")}
                iconName="payments"
                title="Commission Platform"
                text="Browse commission programs, partners, campaigns, and member enrollments."
              />
            </div>
          )}
        </div>
      )}
    </TabLayout>
  );
}
